module.exports = __webpack_public_path__ + "static/media/Cyber-Security.e61aa363.png";